import { keyframes } from '@stitches/react';
import React, { useState, useRef, useEffect } from 'react';
import { styled } from "../../../stitches.config";
import blackbox from '../../../assets/img/natemat/career/blackbox.svg';
import greybox from '../../../assets/img/natemat/career/graybox.svg';
import orangebox from '../../../assets/img/natemat/career/orangebox.svg';
import Picture from '../../../components/Article/Parts/Picture';

const images = {
    'box1': [
        'https://m.natemat.pl/9413843ab11bcef86355bc46070d027e,600,0,0,0.jpg',
        'https://m.natemat.pl/4460478b066b72f248fc104017827307,600,600,1,0.jpg',
        'https://m.natemat.pl/58233ec13a31e689a0e3d9a3ea01bb5b,600,600,1,0.jpg',
        greybox,
        'https://m.natemat.pl/db8c5ec79f95ee2769b0879b202a530d,780,0,0,0.webp',
        'https://m.natemat.pl/389eaef85b10d48b7e176be372c39f65,300,0,0,0.jpg',
    ],
    'box2': [
        greybox,
        'https://m.natemat.pl/21ff11a55408f83bb97d7d15f00accc8,600,600,1,0.jpg',
        greybox,
        'https://m.natemat.pl/31460f64c9b532f2fe9ce66edb881c19,600,600,1,0.jpg',
        'https://m.natemat.pl/d73e693c2fb6a2fd1eb30adfd6ef1a2d,600,600,1,0.jpg',
        'https://m.natemat.pl/ff7937f6fd4dc459af710f4cd84fa4f9,780,0,0,0.webp',
    ],
    'box3': [
        'https://m.natemat.pl/d73e693c2fb6a2fd1eb30adfd6ef1a2d,600,600,1,0.jpg',
        blackbox,
        'https://m.natemat.pl/de7780a5278ce3c568e928eacce9a1c2,780,0,0,0.webp',
        'https://m.natemat.pl/db8c5ec79f95ee2769b0879b202a530d,780,0,0,0.webp',
        'https://m.natemat.pl/2db19e702fee5c56dd17150823ec3388,300,0,0,0.jpg',
        'https://m.natemat.pl/21ff11a55408f83bb97d7d15f00accc8,600,600,1,0.jpg',
    ],
    'box4': [
        'https://m.natemat.pl/fb81a4204ac620595dbff58c91e5bc7c,600,0,0,0.jpg',
        'https://m.natemat.pl/024b40c71f77dd501ca147c0981997a5,600,0,0,0.jpg',
        'https://m.natemat.pl/c11bb8eaaf8fa745e500073ab124f4b1,300,0,0,0.jpg',
        'https://m.natemat.pl/0b851d3df79ea0f712fcf978a08f180e,600,0,0,0.jpg',
        'https://m.natemat.pl/31460f64c9b532f2fe9ce66edb881c19,600,600,1,0.jpg',
        'https://m.natemat.pl/aeef3a162963df3594283772520331b6,600,0,0,0.jpg',
    ],
    'box5': [
        'https://m.natemat.pl/049e38c2263baa27ba4416bce66c18d1,780,0,0,0.webp',
        greybox,
        'https://m.natemat.pl/ff7937f6fd4dc459af710f4cd84fa4f9,780,0,0,0.webp',
        'https://m.natemat.pl/5ae11db418de6665e0a5859cdb75bf07,600,600,1,0.jpg',
        'https://m.natemat.pl/31460f64c9b532f2fe9ce66edb881c19,600,600,1,0.jpg',
        'https://m.natemat.pl/07ff0404c114202bc9030340c9604e5d,300,0,0,0.jpg',
    ],
    'box6': [
        blackbox,
        'https://m.natemat.pl/d6d52569b2db0d0eece02332571fca92,600,0,0,0.jpg',
        greybox,
        'https://m.natemat.pl/9f7675c3a5409782cd2ad41d1b67c0b4,300,0,0,0.jpg',
        'https://m.natemat.pl/9413843ab11bcef86355bc46070d027e,600,0,0,0.jpg',
        blackbox,
    ],
    'box7': [
        'https://m.natemat.pl/993db6132987767ca1df1a8328c4baa8,780,0,0,0.webp',
        'https://m.natemat.pl/e96ab5e1b077cdca84301edc6c129910,300,0,0,0.jpg',
        'https://m.natemat.pl/5ae11db418de6665e0a5859cdb75bf07,600,600,1,0.jpg',
        orangebox,
        'https://m.natemat.pl/4460478b066b72f248fc104017827307,600,600,1,0.jpg',
        'https://m.natemat.pl/58233ec13a31e689a0e3d9a3ea01bb5b,600,600,1,0.jpg',
    ],
    'box8': [
        'https://m.natemat.pl/049e38c2263baa27ba4416bce66c18d1,780,0,0,0.webp',
        orangebox,
        'https://m.natemat.pl/aeef3a162963df3594283772520331b6,600,0,0,0.jpg',
        'https://m.natemat.pl/de7780a5278ce3c568e928eacce9a1c2,780,0,0,0.webp',
        'https://m.natemat.pl/b66135c0d40c4d546395e56fc57c537a,600,0,0,0.jpg',
        'https://m.natemat.pl/9f7675c3a5409782cd2ad41d1b67c0b4,300,0,0,0.jpg',
    ],
    'box9': [
        'https://m.natemat.pl/389eaef85b10d48b7e176be372c39f65,300,0,0,0.jpg',
        'https://m.natemat.pl/4460478b066b72f248fc104017827307,600,600,1,0.jpg',
        orangebox,
        'https://m.natemat.pl/993db6132987767ca1df1a8328c4baa8,780,0,0,0.webp',
        orangebox,
        'https://m.natemat.pl/58233ec13a31e689a0e3d9a3ea01bb5b,600,600,1,0.jpg',
    ],
}

type TeamImageGridProps = {
    isDesktop: boolean,
}

const TeamImageGrid = ({ isDesktop }: TeamImageGridProps) => {

    const [currentTopImage, setCurrentTopImage] = useState<number>(0);
    const [currentBottomImage, setCurrentBottomImage] = useState<number>(1);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTopImage(currentTopImage => currentTopImage + 1);
            setCurrentBottomImage(currentBottomImage => currentBottomImage + 1);
        }, 2000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        if (currentTopImage === 6)
            setCurrentTopImage(0);
        if (currentBottomImage === 6)
            setCurrentBottomImage(0)
    }, [currentTopImage, currentBottomImage]);

    if (isDesktop) {
        return (
            <TeamImageGridContainer>
                <TeamImageGridItems>
                    <ImageRow row='one'>
                        <Box style={{ width: '324px', height: '324px' }}>
                            <div>
                                <Picture
                                    picture={{
                                        img: images.box1[currentTopImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                            <div className='bottom'>
                                <Picture
                                    picture={{
                                        img: images.box1[currentBottomImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                        </Box>
                        <ImageWrap style={{ flexDirection: 'column' }}>
                            <Box style={{ width: '192px', height: '192px' }}>
                                <div>
                                    <Picture
                                        picture={{
                                            img: images.box2[currentTopImage],
                                            disablePreload: true,
                                        }}
                                        key={Math.random()}
                                    />
                                </div>
                                <div className='bottom'>
                                    <Picture
                                        picture={{
                                            img: images.box2[currentBottomImage],
                                            disablePreload: true,
                                        }}
                                        key={Math.random()}
                                    />
                                </div>
                            </Box>
                            <Box style={{ width: '192px', height: '192px' }}>
                                <div>
                                    <Picture
                                        picture={{
                                            img: images.box3[currentTopImage],
                                            disablePreload: true,
                                        }}
                                        key={Math.random()}
                                    />
                                </div>
                                <div className='bottom'>
                                    <Picture
                                        picture={{
                                            img: images.box3[currentBottomImage],
                                            disablePreload: true,
                                        }}
                                        key={Math.random()}
                                    />
                                </div>
                            </Box>
                        </ImageWrap>
                        <Box style={{ width: '408px', height: '408px' }}>
                            <div>
                                <Picture
                                    picture={{
                                        img: images.box4[currentTopImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                            <div className='bottom'>
                                <Picture
                                    picture={{
                                        img: images.box4[currentBottomImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                        </Box>
                        <Box style={{ width: '192px', height: '192px' }}>
                            <div>
                                <Picture
                                    picture={{
                                        img: images.box5[currentTopImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                            <div className='bottom'>
                                <Picture
                                    picture={{
                                        img: images.box5[currentBottomImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                        </Box>
                    </ImageRow>
                    <ImageRow row='two'>
                        <Box style={{ width: '192px', height: '192px' }}>
                            <div>
                                <Picture
                                    picture={{
                                        img: images.box6[currentTopImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                            <div className='bottom'>
                                <Picture
                                    picture={{
                                        img: images.box6[currentBottomImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                        </Box>
                        <Box style={{ width: '300px', height: '300px' }}>
                            <div>
                                <Picture
                                    picture={{
                                        img: images.box7[currentTopImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                            <div className='bottom'>
                                <Picture
                                    picture={{
                                        img: images.box7[currentBottomImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                        </Box>
                        <Box style={{ width: '408px', height: '408px' }}>
                            <div>
                                <Picture
                                    picture={{
                                        img: images.box8[currentTopImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                            <div className='bottom'>
                                <Picture
                                    picture={{
                                        img: images.box8[currentBottomImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                        </Box>
                        <Box style={{ width: '216px', height: '216px' }}>
                            <div>
                                <Picture
                                    picture={{
                                        img: images.box9[currentTopImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                            <div className='bottom'>
                                <Picture
                                    picture={{
                                        img: images.box9[currentBottomImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                        </Box>
                    </ImageRow>
                </TeamImageGridItems>
            </TeamImageGridContainer>
        )
    } else {
        return (
            <TeamImageGridContainer>
                <TeamImageGridItems style={{ alignItems: 'center' }}>
                    <ImageRow row='one'>
                        <ImageWrap style={{ flexDirection: 'column', alignItems: 'flex-end' }}>
                            <Box style={{ width: '49px', height: '49px' }}>
                                <div>
                                    <Picture
                                        picture={{
                                            img: images.box1[currentTopImage],
                                            disablePreload: true,
                                        }}
                                        key={Math.random()}
                                    />
                                </div>
                                <div className='bottom'>
                                    <Picture
                                        picture={{
                                            img: images.box1[currentBottomImage],
                                            disablePreload: true,
                                        }}
                                        key={Math.random()}
                                    />
                                </div>
                            </Box>
                            <Box style={{ width: '76px', height: '76px' }}>
                                <div>
                                    <Picture
                                        picture={{
                                            img: images.box2[currentTopImage],
                                            disablePreload: true,
                                        }}
                                        key={Math.random()}
                                    />
                                </div>
                                <div className='bottom'>
                                    <Picture
                                        picture={{
                                            img: images.box2[currentBottomImage],
                                            disablePreload: true,
                                        }}
                                        key={Math.random()}
                                    />
                                </div>
                            </Box>
                        </ImageWrap>
                        <Box style={{ width: '160px', height: '160px' }}>
                            <div>
                                <Picture
                                    picture={{
                                        img: images.box3[currentTopImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                            <div className='bottom'>
                                <Picture
                                    picture={{
                                        img: images.box3[currentBottomImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                        </Box>
                    </ImageRow>
                    <ImageRow row='two'>
                        <ImageWrap style={{ alignItems: 'flex-end' }}>
                            <Box style={{ width: '76px', height: '76px' }}>
                                <div>
                                    <Picture
                                        picture={{
                                            img: images.box4[currentTopImage],
                                            disablePreload: true,
                                        }}
                                        key={Math.random()}
                                    />
                                </div>
                                <div className='bottom'>
                                    <Picture
                                        picture={{
                                            img: images.box4[currentBottomImage],
                                            disablePreload: true,
                                        }}
                                        key={Math.random()}
                                    />
                                </div>
                            </Box>
                            <Box style={{ width: '104px', height: '104px' }}>
                                <div>
                                    <Picture
                                        picture={{
                                            img: images.box5[currentTopImage],
                                            disablePreload: true,
                                        }}
                                        key={Math.random()}
                                    />
                                </div>
                                <div className='bottom'>
                                    <Picture
                                        picture={{
                                            img: images.box5[currentBottomImage],
                                            disablePreload: true,
                                        }}
                                        key={Math.random()}
                                    />
                                </div>
                            </Box>
                        </ImageWrap>
                        <ImageWrap style={{ alignItems: 'flex-start' }}>
                            <Box style={{ width: '104px', height: '104px' }}>
                                <div>
                                    <Picture
                                        picture={{
                                            img: images.box6[currentTopImage],
                                            disablePreload: true,
                                        }}
                                        key={Math.random()}
                                    />
                                </div>
                                <div className='bottom'>
                                    <Picture
                                        picture={{
                                            img: images.box6[currentBottomImage],
                                            disablePreload: true,
                                        }}
                                        key={Math.random()}
                                    />
                                </div>
                            </Box>
                            <Box style={{ width: '76px', height: '76px' }}>
                                <div>
                                    <Picture
                                        picture={{
                                            img: images.box7[currentTopImage],
                                            disablePreload: true,
                                        }}
                                        key={Math.random()}
                                    />
                                </div>
                                <div className='bottom'>
                                    <Picture
                                        picture={{
                                            img: images.box7[currentBottomImage],
                                            disablePreload: true,
                                        }}
                                        key={Math.random()}
                                    />
                                </div>
                            </Box>
                        </ImageWrap>
                    </ImageRow>
                    <ImageRow>
                        <Box style={{ width: '76px', height: '76px' }}>
                            <div>
                                <Picture
                                    picture={{
                                        img: images.box8[currentTopImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                            <div className='bottom'>
                                <Picture
                                    picture={{
                                        img: images.box8[currentBottomImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                        </Box>
                        <Box style={{ width: '160px', height: '160px' }}>
                            <div>
                                <Picture
                                    picture={{
                                        img: images.box9[currentTopImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                            <div className='bottom'>
                                <Picture
                                    picture={{
                                        img: images.box9[currentBottomImage],
                                        disablePreload: true,
                                    }}
                                    key={Math.random()}
                                />
                            </div>
                        </Box>
                    </ImageRow>
                </TeamImageGridItems>
            </TeamImageGridContainer>
        )
    }

}

export default TeamImageGrid;

const TeamImageGridContainer = styled('div', {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
})

const TeamImageGridItems = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '700px',
    '@bp4': {
        gap: '24px',
        width: '1300px',
    }
})

const ImageRow1 = styled('div', {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    '@bp4': {
        gap: '24px'
    }
})

const ImageRow = styled('div', {
    display: 'flex',
    gap: '8px',
    '@bp4': {
        gap: '24px'
    },
    variants: {
        row: {
            one: {
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
            },
            two: {
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
            }
        }
    }
})

const ImageWrap = styled('div', {
    display: 'flex',
    gap: '8px',
    '@bp4': {
        gap: '24px',
    }
})

const animation = keyframes({
    '0%': {
        opacity: 0,
    },
    '100%': {
        opacity: 1,
    }
})

const Box = styled('div', {
    position: 'relative',
    'div': {
        position: 'absolute',
        width: '100%',
        height: '100%',
        'div': {
            'picture': {
                'img': {
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    userSelect: 'none',
                },
            }
        },
        '&.bottom': {
            'div': {
                'picture': {
                    'img': {
                        animation: `${animation} 1000ms`
                    }
                }
            }
        }
    }
})